export default __webpack_public_path__ + "static/media/no-filters.b7a3f4e8.png";